import React from "react";
import "./InformationalPages.css";
import useTitle from '../hooks/useTitle';
import "./About.css";

const About = () => {
    useTitle('About');

    return (
        <div className="ffls-info-page">
            <div className="login-box legal-container ffls-info-panel">
                <h1>About FFLS.io</h1>
                <p>
                    FFLS.io is an independent online platform designed to help Federal Firearms License (FFL) holders
                    connect with potential customers, showcase their services, and manage their online presence through
                    customizable dealer microsites.
                </p>

                <h3>Our Mission</h3>
                <p>
                    Our mission is to provide licensed dealers, gunsmiths, and firearm-related businesses with simple,
                    effective tools to build a professional web presence, improve discoverability, and streamline
                    customer interactions — while staying within the boundaries of federal, state, and local regulations.
                </p>

                <h3>What We Provide</h3>
                <ul>
                    <li>Searchable FFL dealer directory by name or geographic location.</li>
                    <li>Customizable dealer websites hosted under <strong>ffls.io</strong> subdomains.</li>
                    <li>Tools to update business hours, services, specialties, and contact details.</li>
                    <li>Secure file uploads for FFL license verification and renewals.</li>
                    <li>Automated status updates for pending, approved, and renewed licenses.</li>
                </ul>

                <h3>Legal Disclaimers</h3>
                <p>
                    FFLS.io is <strong>not</strong> a firearms dealer, broker, or marketplace. We do not engage in the sale,
                    transfer, or shipment of firearms or ammunition. We do not verify the accuracy of information provided
                    by FFL holders beyond uploaded licensing documents and basic verification steps.
                </p>
                <p>
                    All compliance with the Bureau of Alcohol, Tobacco, Firearms, and Explosives (ATF) regulations,
                    state laws, and local ordinances is the sole responsibility of the FFL holder. FFLS.io is not
                    responsible for any legal violations, disputes, or transactions between dealers and customers.
                </p>

                <h3>Data Accuracy</h3>
                <p>
                    Dealer information is provided by the FFL holder or sourced from publicly available ATF data. While we
                    strive to maintain accuracy, FFLS.io does not guarantee that all listings are complete, current, or
                    error-free. Users should verify all information directly with the dealer.
                </p>

                <h3>Contact Us</h3>
                <p>
                    For support, feedback, or inquiries about FFLS.io, please email us at{" "}
                    <a href="mailto:support@ffls.io">support@ffls.io</a>.
                </p>
            </div>
        </div>
    );
};

export default About;